/* V-Tight 3.5.9 – persistent cart confirmation; not a blocking modal. */
(() => {
  'use strict';
  const popup = document.getElementById('vt359-cart-confirm');
  if (!popup) return;
  const title = popup.querySelector('[data-vt359-title]');
  const price = popup.querySelector('[data-vt359-price]');
  const image = popup.querySelector('[data-vt359-image]');
  const fallback = popup.querySelector('[data-vt359-fallback]');
  const count = popup.querySelector('[data-vt359-count]');
  const closeBtn = popup.querySelector('.vt359-cart-close');
  let returnFocus = null;
  const formatter = new Intl.NumberFormat('nl-NL', {
    style:'currency', currency: window.Shopify?.currency?.active || 'EUR'
  });
  function close() {
    if (popup.hidden) return;
    popup.hidden = true;
    document.body.classList.remove('vt359-cart-open');
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
    returnFocus = null;
  }
  function show(item, options = {}) {
    if (!item || typeof item !== 'object') return false;
    returnFocus = options.trigger || document.activeElement;
    let productTitle = String(item.product_title || item.title || 'V-Tight verzorgingsgel');
    if (/4.pack|4\s*[×x]\s*100/i.test(productTitle)) productTitle = 'V-Tight 4-Pack · 4 × 100 ml';
    else if (/trio|3\s*[×x]\s*100/i.test(productTitle)) productTitle = 'V-Tight Trio · 3 × 100 ml';
    else if (/duo|2\s*[×x]\s*100/i.test(productTitle)) productTitle = 'V-Tight Duo · 2 × 100 ml';
    else if (/single|100\s*ml/i.test(productTitle)) productTitle = 'V-Tight Single · 100 ml';
    title.textContent = productTitle;
    const amount = typeof item.final_price === 'number' ? item.final_price : item.price;
    price.textContent = Number.isFinite(amount) ? formatter.format(amount/100) : '';
    const candidate = typeof item.image === 'string' ? item.image : item.featured_image?.url;
    if (candidate && /^(https?:\/\/|\/)/i.test(candidate)) {
      image.src = candidate;
      image.alt = productTitle;
      image.hidden = false;
      fallback.hidden = true;
    } else {
      image.removeAttribute('src');
      image.hidden = true;
      fallback.hidden = false;
    }
    const cartCount = Number(options.count);
    count.textContent = Number.isFinite(cartCount) && cartCount > 0 ? ' ('+cartCount+')' : '';
    popup.hidden = false;
    document.body.classList.add('vt359-cart-open');
    closeBtn.focus({preventScroll:true});
    return true;
  }
  popup.querySelectorAll('[data-vt359-close]').forEach(button=>button.addEventListener('click',close));
  document.addEventListener('keydown',event=>{
    if(event.key === 'Escape' && !popup.hidden) {event.preventDefault();close();}
  });
  window.VTightCartConfirm = Object.freeze({show, close});
})();